import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { useContext } from 'react';
import { ViewportContext } from '../../../hooks/useViewport';
import { SlotMachineSymbol } from '../../slotMachines/SlotMachineSymbol';
import { styleSheet } from '../styles';

const PRIZE_COIN_HEIGHT = 26;

interface IProps {
	date: string;
	name: string;
	prize: string;
}

export const PrizesList: React.FC<IProps> = ({ date, name, prize }) => {
	const { isBelowSmall } = useContext(ViewportContext);
	const formattedDate = moment(date).format('MM/DD/YYYY');

	return (
		<div className={css(styleSheet.prizeRow)}>
			<SlotMachineSymbol
				type={Api.SlotMachineSymbol.LevitateCoin}
				styles={[styleSheet.prizeCoin]}
				style={{ height: PRIZE_COIN_HEIGHT, width: 'auto' }}
			/>
			{isBelowSmall ? (
				<div className={css(styleSheet.prizeMobileDetails)}>
					<span className={css(styleSheet.prizeName)}>{name}</span>
					<span className={css(styleSheet.prizeDate)}>
						{formattedDate} · <span className={css(styleSheet.prizeReward)}>{prize}</span>
					</span>
				</div>
			) : (
				<>
					<span className={css(styleSheet.prizeName)} title={name}>
						{name}
					</span>
					<span className={css(styleSheet.prizeDate)}>{formattedDate}</span>
					<span className={css(styleSheet.prizeReward)}>{prize}</span>
				</>
			)}
		</div>
	);
};
